/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./interactive-type-config.vue?vue&type=template&id=6556f1d6&"
import script from "./interactive-type-config.vue?vue&type=script&lang=js&"
export * from "./interactive-type-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports